module.exports = __webpack_public_path__ + "static/media/karajan_dashboard_web_mobile_background_blur.d7939b39.jpg";